export const CAMPAIGN_VERIFICATION_PATH = '/dashboard/campaign-verification'
